export type TrainingLessonModel = {
  cache_key: number,
  data: any,
  description: string,
  id: number,
  lesson_alias_id?: number,
  title: string,
  training_module_id: number,
}

export type TrainingLessonRequestOptions = {}

const state = {
  data: {},
  description: '',
  id: null,
  lesson_alias_id: undefined,
  title: '',
  training_module_id: undefined,
}

export const requiredFields = [
  { key: 'description' },
  { key: 'title' },
  { key: 'training_module_id' },
]

export default state
